import e from "../managers/braze-instance.js";
import { InternalEventTypes as or } from "../../shared-lib/index.js";
export function logFeedDisplayed() {
  var r;
  if (e.X())
    return null === (r = e.nr()) || void 0 === r ? void 0 : r.qr(or.Br).L;
}
